import { paymentUrls } from '@/configs/endpoints'
import api from '@/plugins/api'

export default {
  state: () => ({
    paymentUrls: {},
    isLoad: false,
    paymentHistory: [],
    paymentMethods: []
  }),
  mutations: {
    SET_DATA_PAYMENT(state, data) {
      Object.entries(data).forEach(entry => {
        state[entry[0]] = entry[1]
      })
    }
  },
  actions: {
    async getPaymentMethods({ commit }) {
      try {
        const response = await api.get(paymentUrls.payment_methods + '?cabinet_type=web')
        if (response?.code === 200) {
          commit('SET_DATA_PAYMENT', { paymentMethods: response.data })
        }
      } catch (error) {
        console.error(error)
      }
    },
    async payWithPrivat24(_, body) {
      try {
        const response = await api.post(paymentUrls.privat, { body })
        return response.data
      } catch (error) {
        console.error(error)
      }
    },
    async payWithLiqPay(_, body) {
      try {
        const response = await api.post(paymentUrls.liqpay, { body })
        return response.data
      } catch (error) {
        console.error(error)
      }
    },
    async payWithMono(_, body) {
      try {
        const response = await api.post(paymentUrls.monobank, { body })
        return response.data
      } catch (error) {
        console.error(error)
      }
    },
    async payWithEasyPay(_, body) {
      try {
        const response = await api.post(paymentUrls.easypay, { body })
        return response.data
      } catch (error) {
        console.error(error)
      }
    },
    async payWithPlaton(_, body) {
      try {
        const response = await api.post(paymentUrls.platon_invoice, { body })
        return response.data
      } catch (error) {
        console.error(error)
      }
    },
    async payWithHutko(_, body) {
      try {
        const response = await api.post(paymentUrls.hutko, { body })
        return response.data
      } catch (error) {
        console.error(error)
      }
    }
  }
}
